import { toast } from 'react-toastify';

import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestComboios({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'comboios', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* deleteComboio({ payload }) {
  try {
    const { idposto, params } = payload;

    yield call(api.delete, `comboios/${idposto}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* store({ payload }) {
  try {
    const { comboio, params } = payload;

    yield call(api.post, 'comboios', comboio);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/comboios');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* find({ payload }) {
  try {
    const { idposto } = payload;

    const { data } = yield call(api.get, `comboios/${idposto}`);
    yield put(successRequest(data));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* update({ payload }) {
  try {
    const { comboio, params } = payload;

    yield call(api.put, 'comboios', comboio);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/comboios');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'comboios', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export default all([
  takeLatest('@comboio/COMBOIOS_IN_REQUEST', requestComboios),
  takeLatest('@comboio/DELETE_COMBOIO', deleteComboio),
  takeLatest('@comboio/SUCCESS_REMOVE', requestComboios),
  takeLatest('@comboio/STORE_COMBOIO', store),
  takeLatest('@comboio/FIND_COMBOIO', find),
  takeLatest('@comboio/UPDATE_COMBOIO', update),
  takeLatest('@comboio/RECORD_FILTERING', applyedFilters),
]);
